import { useMemo } from "react";

import { useBooking } from "../../providers/BookingProvider";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import DropdownSmall from "../elements/DropdownSmall.tsx";

const TopBar: React.FC = () => {
  const {
    selectedMakeModelId,
    handleMakeModelChange,
    availableVariants,
    selectedVariants,
    handleVariantChange,
  } = useVehicleSelection();

  const { vehicles } = useBooking();
  // const { clearCart } = useCart();

  const vehicleOptions = useMemo(() => {
    // Get unique make/model combinations
    const makeModelMap = new Map<string, number>();

    const makes = vehicles.filter((vehicle) => vehicle.parent === 0);
    for (const make of makes) {
      for (const model of make.children) {
        const key = `${make.name} ${model.name}`;
        makeModelMap.set(key, model.id);
      }
    }

    return Array.from(makeModelMap.entries()).map(([label, value]) => ({
      label,
      value: value.toString(),
    }));
  }, [vehicles]);

  return (
    <div className="py-4 px-4 lg:px-2 flex justify-between lg:justify-between gap-4 bg-[#cccccc] lg:bg-white">
      <div className="flex gap-4 w-full justify-evenly lg:w-auto">
        <DropdownSmall
          options={vehicleOptions}
          selected={selectedMakeModelId?.toString() ?? ""}
          onChange={(value) => {
            handleMakeModelChange(value === "" ? null : Number(value));
            // clearCart();
          }}
          defaultOption="Select Make & Model"
        />
        {availableVariants.map((variant, index) => (
          <DropdownSmall
            key={index}
            options={variant.values.map((variant) => ({
              label: variant.name,
              value: variant.id.toString(),
            }))}
            selected={selectedVariants[index]?.id?.toString() || ""}
            onChange={(value) => {
              handleVariantChange(index, Number(value));
            }}
            defaultOption={"Select " + variant.label}
          />
        ))}
      </div>
    </div>
  );
};

export default TopBar;
